import { connect } from "react-redux";
import { selectEstateListItems } from "@/modules/estate/estateList/estateListSlice";
import { selectCurrentUser } from "@/modules/user/userActions";
import { currentEstateSelectors } from "@/modules/estate/currentEstate/currentEstateSlice";
import type { RootState } from "@/store/store";

/**
 * A redux helper to decorate a component with a currentUser object.
 */
export const withCurrentUser = () => {
  const mapStateToProps = (state: RootState) => ({
    currentUser: selectCurrentUser(state),
  });
  return connect(mapStateToProps);
};

/**
 * Example usage:
 *
 * const enhance = compose(
 *  withCurrentEstate(options)
 * );
 *
 * A redux helper to decorate a component with the currentEstate object.
 */
export const withCurrentEstate = (/** options if necessary */) => {
  const mapStateToProps = (state: RootState) => ({
    currentEstate: currentEstateSelectors.selectCurrentEstate(state),
  });
  return connect(mapStateToProps);
};

/**
 * Example usage:
 *
 * const enhance = compose(
 *  withEstates(options)
 * );
 *
 * A redux helper to decorate a component with the estates by userId.
 */
export const withEstates = () => {
  const mapStateToProps = (state: RootState) => ({
    estates: selectEstateListItems(state),
  });
  return connect(mapStateToProps);
};
